import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountService } from '../../services/account.service';

@Injectable({ providedIn: 'root' })
export class ApiInterceptor implements HttpInterceptor {

  constructor(private accountService: AccountService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('api/Editors_v2') || req.url.includes('api/FileManager_v2')) {
      let sessionParams = req.params
        .append('accountKey', this.accountService.accountKey)
        .append('id', this.accountService.pageid)
        .append('userlcid', this.accountService.userlcid)
        .append('typeName', this.accountService.typename)
        .append('orgName', this.accountService.orgname)
        .append('callerPage', 'ddeditor')
        .append('userid', this.accountService.userid)
        .append('Issplittesting', this.accountService.issplittesting)
        .append('sessionId', this.accountService.sessionId)
        .append('stpid', this.accountService.stpId);

      if (this.accountService.isrss) {
        sessionParams = sessionParams.append('isrss', 'true');
      }

      const withSessionInfoReq = req.clone({ params: sessionParams });
      return next.handle(withSessionInfoReq);
    }
    return next.handle(req);
  }
}
